import React from 'react'
import { Row, Col } from 'antd'
import { routersHelper } from '../../helpers'

const TabArea = () => {
    const { useRouter } = routersHelper
    const router = useRouter()
    return (
        <Row className="camera-bar">
            <Col span={24}>
                VRoom: {router.query.roomName}
            </Col>
        </Row>
    )
}

export default TabArea